import { Component, Output, EventEmitter, OnInit, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalAcessoRestritoComponent } from '../../saida-gate/modal-acesso-restrito/modal-acesso-restrito.component';
import {
  ICreateMovimentacaoCaixa,
  IUpdateMovimentacaoCaixa
} from 'src/app/services/CaixaService/caixa.model';
import { formatarData } from 'src/app/core/utils/utilities';
import { CaixaService } from 'src/app/services/CaixaService/caixa.service';
import { generateUUID } from 'src/app/core/generators/generateUUID';

@Component({
  selector: 'app-modal-sangria-caixa',
  templateUrl: './modal-sangria-caixa.component.html',
  styleUrls: ['./modal-sangria-caixa.component.scss']
})
export class ModalSangriaCaixaComponent implements OnInit {
  @Output() permitirEntrada = new EventEmitter<void>();
  form: FormGroup;
  isLoading: boolean = false;
  guid = generateUUID();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalAcessoRestritoComponent>,
    private fb: FormBuilder,
    private caixaService: CaixaService
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.activateRoute();
  }

  initForm() {
    const form = this.fb.group({
      NU_MOVM_CAIX: [2, Validators.required],
      VL_MOVM_CAIX: [0, Validators.required],
      FK_CAIX: [null, Validators.required],
      FK_FUNC_OPER: [null, Validators.required],
      TX_MOTV_MOVM_CAIX: [''],
      NM_FUNC_OPER: [''],
      DT_MOVM_CAIX: ['']
    });
    return form;
  }

  postSangria() {
    this.isLoading = true;
    const payload = this.createPayload();
    const serviceCall = !this.data.EDIT_ITEM
      ? this.caixaService.CreateMovimentacaoCaixa(payload, this.guid)
      : this.caixaService.UpdateMovimentacaoCaixa(
          this.data.PK_MOVM_CAIX,
          payload
        );

    serviceCall.subscribe({
      next: () => ((this.isLoading = false), location.reload()),
      error: () => ((this.isLoading = false), this.onCancelar())
    });
  }

  onCancelar(): void {
    this.dialogRef.close();
  }

  createPayload(): ICreateMovimentacaoCaixa | IUpdateMovimentacaoCaixa | any {
    return {
      NU_MOVM_CAIX: 2,
      VL_MOVM_CAIX: this.form.get('VL_MOVM_CAIX')?.value,
      FK_CAIX: this.form.get('FK_CAIX')?.value,
      FK_FUNC_OPER: this.form.get('FK_FUNC_OPER')?.value,
      TX_MOTV_MOVM_CAIX: this.form.get('TX_MOTV_MOVM_CAIX')?.value,
      PermissionToken: this.data.PermissionToken
    };
  }

  activateRoute(): void {
    this.isLoading = true;
    setTimeout(() => (this.isLoading = false), 350);
    if (this.data.EDIT_ITEM) {
      this.caixaService
        .GetMovimentacaoCaixaById(this.data.PK_MOVM_CAIX)
        .subscribe({
          next: res => {
            this.form.controls['VL_MOVM_CAIX'].setValue(res.VL_MOVM_CAIX);
            this.form.controls['TX_MOTV_MOVM_CAIX'].setValue(
              res.TX_MOTV_MOVM_CAIX
            );
          }
        });
    }

    const FK_FUNC_OPER = localStorage.getItem('id');
    const NM_FUNC_OPER = localStorage.getItem('nome');

    this.form.controls['FK_CAIX'].setValue(this.data.PK_CAIX);
    this.form.controls['FK_FUNC_OPER'].setValue(FK_FUNC_OPER);
    this.form.controls['NM_FUNC_OPER'].setValue(NM_FUNC_OPER);
    this.form.controls['DT_MOVM_CAIX'].setValue(formatarData(new Date()));
  }
}
